import { Flex, Icon, useBreakpointValue } from "@chakra-ui/react"
import { useEffect, useState } from "react";
import { MdQrCodeScanner } from 'react-icons/md';
import { useHistory } from "react-router-dom";

import { useAuth } from "../../hooks/auth";
import Logo from "./Logo";
import NotificationNav from "./NotificationNav";
import PopoverUser from "./PopoverUser";
import SearchBox from "./SearchBox";
import { SelectCompany } from "./SelectCompany";

interface HeaderProps {
	isOpenCart?: (open: boolean) => void;
	handleSearchProduct?: (search: string) => void;
	setIsOpenScanner?: (open: boolean) => void;
	isOpenScanner?: boolean;
	isVisibleBtnScanner?: boolean;
}

const Header: React.FC<HeaderProps> = ({
	isOpenCart,
	handleSearchProduct,
	setIsOpenScanner,
	isOpenScanner,
	isVisibleBtnScanner,
}) => {

	const [loading, setLoading] = useState(true);

	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const history = useHistory();
	const { lojas } = useAuth();

	const options = lojas.map(loja => {
		return { value: loja.id, label: loja.fantazia }
	});

	useEffect(() => {
		setLoading(false);
	}, [])

	return (
		<Flex
			w="100%"
			bg="gray.800"
			position="fixed"
			top={0}
			left={0}
			zIndex="10"
			flexDir={history.location.pathname === '/products' && !isWideVersion ? 'column' : 'row'}
		>
			<Flex
				as="header"
				w="100%"
				h={["50px", "60px"]}
				// maxW={1680}
				px={[2, 8]}
				justify="space-between"
				align="center"
			>
				<Logo />

				{history.location.pathname === '/products' && isWideVersion && !loading && (
					<>
						<SearchBox handleSearchProduct={handleSearchProduct} />

						{isVisibleBtnScanner && (
							<Flex
								as="button"
								onClick={() => {
									setIsOpenScanner && setIsOpenScanner(!isOpenScanner);
									// history.push('/scan');
								}}
							>
								<Icon
									as={MdQrCodeScanner}
									mr={6}
									fontSize={30}
									color="white"
									_hover={{ color: "blue.100" }}
								/>
							</Flex>
						)}
					</>
				)}

				<Flex>
					<NotificationNav isOpenCart={isOpenCart} />

					<SelectCompany options={options} />

					<PopoverUser />
				</Flex>
			</Flex>

			{history.location.pathname === '/products' && !isWideVersion && !loading &&
				<Flex w="100%" pb="2">
					<SearchBox handleSearchProduct={handleSearchProduct} />

					{isVisibleBtnScanner && (
						<Flex
							as="button"
							onClick={() => setIsOpenScanner && setIsOpenScanner(!isOpenScanner)}
						>
							<Icon
								as={MdQrCodeScanner}
								mr={6}
								fontSize={30}
								color="white"
								_hover={{ color: "blue.100" }}
							/>
						</Flex>
					)}
				</Flex>
			}
		</Flex>
	)
};

export default Header;
